export const getFirstTwoCharsFromFullName = (fullName: string) => {
  const [firstName, lastName] = fullName.split(' ');
  const first = firstName ? firstName.charAt(0) : 'J';
  const last = lastName ? lastName.charAt(0) : 'A';
  return `${first}${last}`;
};
